export class RunAsyncUntilCompleteRequestFailedError extends Error {}
